import _objectSpread from "@babel/runtime/helpers/objectSpread2";
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import pick from 'lodash/pick';
import HttpClientModule from './http-client';
import ServiceSDKModule from './service-sdk';
import IdentitySDKModule, * as IdentitySDKExports from './identity-sdk';
import DiyServicesSDKModule from './diy-services-sdk';
import AbSDKModule from './ab-sdk';
/*
Return an NWApiSDK library instance.
Note that NWApiSDK instances do hold state, namely "identify" tracking state inside ServiceSDK.

config:
- clientID: your FE app's unique client ID
- cookieDomain: the parent NW domain for your app's current environment (e.g., '.nerdwallet.com')
- identityBaseUrl: the identity services base URL for your current environment
  (e.g., 'http://identity.localnerd.nerdwallet.com')
- identityAntifraudPass: Whether to use antifraud=PASS url parameter
- userDataPlatformBaseUrl: the user data platform base URL for your current environment
  (e.g., config.SERVICE_URLS.USER_DATA)
- abUrl: the ab services URL for your current environment. For stage/prod this should be internal
  (e.g., 'http://ab-0.east1.stage.nerdwallet.biz:8000')
- abExperimentList: a array of all experiment test names for which this app cares about.
- abExperimentsAtPath: (optional) an object that maps current path -> active experiments
- getCookies: (optional) Custom cookie access logic
- getCookieIdOverride: (optional) Custom cookie id access logic
- getBrowserSessionIdOverride: (optional) Custom browser id access logic
- getPageviewId: (optional) Custom hook to get current pageview id, used to
  set X-Pageview-ID header on requests
- getUrl: (optional) Custom hook to get current url, used to set
  X-Originating-Url header on requests
*/

var initNwApiSdk = function initNwApiSdk(config) {
  var httpClient = config.httpClient;

  if (!httpClient) {
    httpClient = HttpClientModule(pick(config, ['nwa', 'nets', 'applicationID', 'clientID', 'xhrTimeout', 'getCookies', 'getCookieIdOverride', 'getBrowserSessionIdOverride', 'getPageviewId', 'getUrl', 'uuid', 'enableHeadersAndMeta']));
  }

  var ServiceSDK = config.ServiceSDK;

  if (!ServiceSDK) {
    ServiceSDK = ServiceSDKModule(_objectSpread({
      httpClient: httpClient
    }, pick(config, ['nwa', 'nets', 'applicationID', 'clientID', 'xhrTimeout', 'getCookies', 'getCookieIdOverride', 'getBrowserSessionIdOverride', 'getPageviewId', 'getUrl', 'uuid', 'enableHeadersAndMeta'])));
  }

  var IdentitySDK = IdentitySDKModule(ServiceSDK, pick(config, ['identityBaseUrl', 'identityAntifraudPass', 'userDataPlatformBaseUrl', 'getCookies', 'enableHeadersAndMeta', 'shimUDP', 'UDPMemberProfilesList', 'visitorIdentityBaseUrl']));
  var DiyServicesSDK = DiyServicesSDKModule(ServiceSDK, config.diyServicesBaseUrl);
  var AbSDK = AbSDKModule(ServiceSDK, config.abUrl, config.abExperimentList, config.abExperimentsAtPath);
  return {
    httpClient: httpClient,
    ServiceSDK: ServiceSDK,
    IdentitySDK: IdentitySDK,
    DiyServicesSDK: DiyServicesSDK,
    AbSDK: AbSDK,
    cookieDomain: config.cookieDomain,
    identityBaseUrl: config.identityBaseUrl,
    abUrl: config.abUrl,
    abExperimentList: config.abExperimentList,
    abExperimentsAtPath: config.abExperimentsAtPath
  };
};

initNwApiSdk.IDENTITY_APPS = IdentitySDKExports.APPS;
initNwApiSdk.IDENTITY_PROFILES = IdentitySDKExports.PROFILES;
initNwApiSdk.IDENTITY_PASSWORD_RESET_URLS = IdentitySDKExports.PASSWORD_RESET_URLS;
initNwApiSdk.IDENTITY_EMAIL_VERIFICATION_URLS = IdentitySDKExports.EMAIL_VERIFICATION_URLS;
initNwApiSdk.IDENTITY_GOAL_SUBTYPES = IdentitySDKExports.GOAL_SUBTYPES;
initNwApiSdk.IDENTITY_GOAL_TYPES = IdentitySDKExports.GOAL_TYPES;
initNwApiSdk.IDENTITY_TOS_ACKNOWLEDGEMENT_TYPE = IdentitySDKExports.TOS_ACKNOWLEDGEMENT_TYPE;
initNwApiSdk.IDENTITY_TOS_ACKNOWLEDGEMENT_SOURCE = IdentitySDKExports.TOS_ACKNOWLEDGEMENT_SOURCE;
initNwApiSdk.IDENTITY_ONBOARDING_TYPES = IdentitySDKExports.ONBOARDING_TYPES;
initNwApiSdk.IDENTITY_ONBOARDING_INTEREST_TYPES = IdentitySDKExports.ONBOARDING_INTEREST_TYPES;
initNwApiSdk.IDENTITY_CURRENT_SAVING_PATTERN_TYPES = IdentitySDKExports.CURRENT_SAVING_PATTERN_TYPES;
initNwApiSdk.IDENTITY_CURRENT_SPENDING_PATTERN_TYPES = IdentitySDKExports.CURRENT_SPENDING_PATTERN_TYPES;
initNwApiSdk.IDENTITY_DEBT_TYPES = IdentitySDKExports.DEBT_TYPES;
initNwApiSdk.IDENTITY_SAVING_TYPES = IdentitySDKExports.SAVING_TYPES;
initNwApiSdk.IDENTITY_SELF_REPORTED_CREDIT_SCORE_RANGES = IdentitySDKExports.SELF_REPORTED_CREDIT_SCORE_RANGES;
initNwApiSdk.IDENTITY_TRANSACTION_BASE_TYPES = IdentitySDKExports.TRANSACTION_BASE_TYPES;
initNwApiSdk.IDENTITY_TRANSACTION_SLICES = IdentitySDKExports.TRANSACTION_SLICES;
initNwApiSdk.IDENTITY_TRANSACTION_TAGS = IdentitySDKExports.TRANSACTION_TAGS;
initNwApiSdk.IDENTITY_PRODUCT_SHOPPING_EVENT_NAMES = IdentitySDKExports.PRODUCT_SHOPPING_EVENT_NAMES;
initNwApiSdk.IDENTITY_PRODUCT_SHOPPING_ACTION_NAMES = IdentitySDKExports.PRODUCT_SHOPPING_ACTION_NAMES;
export default initNwApiSdk;